import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterContentInit,
  ContentChildren,
  QueryList
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormType } from '../../enums/index';
import { TemplateDirective } from './../../directives/template.directive';

@Component({
  selector: 'lib-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss']
})
export class ModalContainerComponent implements OnInit, AfterContentInit {
  @Input() modalTitle: string;
  @Input() loading: boolean = false;
  @Input() formGroup: FormGroup;
  @Input() msgErrors: any[];
  @Output() dismiss: EventEmitter<any> = new EventEmitter();
  @Output() Submit: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Input() formType: FormType;
  @Input() saveText: string = 'Guardar';
  @Input() saveIcon: string = 'save';
  @Input() cancelText: string = 'Cancelar';
  @Input() returnText: string = 'Retornar';
  @Input() draggable: boolean = false;
  @Input() hideSave: boolean = false;
  @Input() noActions: boolean = false;
  @Input() classModalTitle: string = '';

  @ContentChildren(TemplateDirective) templates: QueryList<
    TemplateDirective
  >;
  modalLeftActionsTemplate: any = null;

  FormType = FormType;

  constructor() { }

  ngOnInit() { }

  handleDismiss = () => {
    this.dismiss.emit();
  };

  handleSubmit = () => {
    this.Submit.emit();
  };

  handleClickSave = () => {
    if (!this.formGroup) {
      this.save.emit();
    }
  }

  ngAfterContentInit(): void {
    const tplLeftActions = this.templates.find(
      x => x.getType() === 'left-actions'
    );
    if (tplLeftActions) {
      this.modalLeftActionsTemplate = tplLeftActions.template;
    }
  }
}
